import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { PublicationsService } from 'src/app/Service/publications.service';
import { SharedService } from 'src/app/Service/shared.service';

@Component({
  selector: 'app-programme-prev',
  templateUrl: './programme-prev.component.html',
  styleUrls: ['./programme-prev.component.scss']
})
export class ProgrammePrevComponent implements OnInit {
  description;
  isArab=false;
  outputLg: any;
  currentlang = '';
  currentUrl: string;
  langue: any;
  dataprogrammes;
  Region: any;

  
  constructor(private global: Global, private service: PublicationsService, private shared: SharedService, private route: ActivatedRoute,private router: Router,private translate: TranslateService) { }

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.isArab = lg.code == "ar";
      this.outputLg = lg;
      this.currentlang = lg.url;
      this.currentUrl = this.router.url
      this.langue = lg;
      this.shared.getBlocDescriptionByCode(lg.url, "programme-previsionnel").subscribe(data => {
        this.description = data["value"][0];
        this.service.getRegions().subscribe(reg => {
          this.Region = reg["value"];
          console.log("region",this.Region);
        })
      })
      this.dataprogrammes = [];
      this.service.getProgrammePrev(lg.url).subscribe(data => {
        
        this.dataprogrammes = data["value"];
       // this.dataprogrammes = this.dataprogrammes.filter(element => {return  element["Programme_region"]==true});
        // this.dataOffres = this.OffresGlobals.filter(element => {return  element["Programme_region"]===false});
       console.log(this.dataprogrammes)

      })

  });
  }

  getRegion(region) {
    return this.Region.find(x => x.Id == region).Title
  }

}
